<template>
    <div id="dashboard-security-view">
        <span class="dashboard-title mb-5">Account Security</span>

        <div class="dashboard-boxed-container mb-4">
            <TwoFactorAuthentication />
        </div>
    </div>
</template>

<script>
import TwoFactorAuthentication from '@/components/account/2FA/2FA.vue';
import {mapGetters} from "vuex";

export default {
    components: {
        TwoFactorAuthentication,
    },

    computed: {
        ...mapGetters('User', ['isGuest']),
    }
};
</script>

<style lang="scss" scoped>
</style>
